import { render, staticRenderFns } from "./enterpriseLabel.vue?vue&type=template&id=04bddbad&scoped=true"
import script from "./enterpriseLabel.vue?vue&type=script&lang=js"
export * from "./enterpriseLabel.vue?vue&type=script&lang=js"
import style0 from "./enterpriseLabel.vue?vue&type=style&index=0&id=04bddbad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bddbad",
  null
  
)

export default component.exports